import { AppIdentifier } from "../../types";
import { appIdentifierToActionPrefixMap } from "../../types";
import {
  ACTION_SET_JWT,
  ACTION_SET_MODAL_STATE,
  ACTION_APP_LOADED
} from "./constants";

export interface IPayoutsState {
  jwt: string;
  isAppLoaded: boolean;
  isAppActive: boolean;
}

export interface IPayoutsAction {
  type: string;
  jwt?: string;
  isAppActive?: boolean;
  isAppLoaded?: boolean;
}

const INITIAL_STATE: IPayoutsState = {
  jwt: "",
  isAppActive: false,
  isAppLoaded: false
}

const applySetIsAppActive = (state: IPayoutsState, action: IPayoutsAction) : IPayoutsState => {
  return {
      ...state,
      isAppActive: !!action.isAppActive,
  }
}

const applySetSendJWTToApp = (state: IPayoutsState, action: IPayoutsAction) : IPayoutsState => {
  return {
      ...state,
      isAppLoaded: !!action.isAppLoaded,
  }
}

const applySetJWT = (state: IPayoutsState, action: IPayoutsAction) : IPayoutsState => {
  return {
      ...state,
      jwt: action.jwt as string,
  }
}

const reducerMap: { [actionType: string]: (state: IPayoutsState, action: IPayoutsAction) => IPayoutsState } = {
  // Payouts reducer
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.PAYOUTS)}${ACTION_SET_JWT}`]: applySetJWT,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.PAYOUTS)}${ACTION_SET_MODAL_STATE}`]: applySetIsAppActive,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.PAYOUTS)}${ACTION_APP_LOADED}`]: applySetSendJWTToApp,
};

const payoutsReducer = (state = INITIAL_STATE, action: IPayoutsAction) => {
  if (!!action.type && !!reducerMap[action.type]) {
      return reducerMap[action.type](state, action);
  } else {
      return state;
  }
}

export default payoutsReducer;
